import { DEFAULT_IMAGE, SITE_URL } from "../components/content/SEO/SEO";

// Build a standard meta array for a route's meta() export, replacing the
// per-page react-helmet <SEO> component (which doesn't run under framework-mode
// SSR — RR owns the document head via route meta()). Always emits a full set of
// Open Graph + Twitter card tags (with a site-wide default share image) so links
// render correctly on LinkedIn / Slack / X, and optionally injects JSON-LD.
export function pageMeta(opts: {
  title: string;
  description?: string;
  path?: string; // canonical path, e.g. "/about"
  image?: string;
  type?: "website" | "article";
  jsonLd?: Record<string, any> | Record<string, any>[];
}) {
  const canonical = opts.path ? `${SITE_URL}${opts.path}` : undefined;
  const image = opts.image || DEFAULT_IMAGE;
  const jsonLd = opts.jsonLd ? (Array.isArray(opts.jsonLd) ? opts.jsonLd : [opts.jsonLd]) : [];
  return [
    { title: opts.title },
    ...(opts.description ? [{ name: "description", content: opts.description }] : []),
    ...(canonical ? [{ tagName: "link", rel: "canonical", href: canonical } as const] : []),
    { property: "og:title", content: opts.title },
    ...(opts.description ? [{ property: "og:description", content: opts.description }] : []),
    ...(canonical ? [{ property: "og:url", content: canonical }] : []),
    { property: "og:type", content: opts.type ?? "website" },
    { property: "og:site_name", content: "Gazar" },
    { property: "og:image", content: image },
    { property: "og:image:alt", content: opts.title },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: opts.title },
    ...(opts.description ? [{ name: "twitter:description", content: opts.description }] : []),
    { name: "twitter:image", content: image },
    { name: "twitter:creator", content: "@ehsangazar" },
    ...jsonLd.map((obj) => ({ "script:ld+json": obj })),
  ];
}
